import { render } from "./MobileProductSearch.vue?vue&type=template&id=5247d202&scoped=true"
import script from "./MobileProductSearch.vue?vue&type=script&lang=js"
export * from "./MobileProductSearch.vue?vue&type=script&lang=js"

import "./MobileProductSearch.vue?vue&type=style&index=0&id=5247d202&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5247d202"]])

export default __exports__